const TRACK_ID_PATTERN = /^[a-z][a-z0-9_]{0,63}$/;
const LONG_NUMBER_PATTERN = /\d{7,}/;
const MAX_TRACK_ID_LENGTH = 64;
const TURKISH_LETTER_PATTERN = /[İIıŞşĞğÜüÖöÇç]/g;
const TURKISH_TO_ASCII = {
  İ: "i",
  I: "i",
  ı: "i",
  Ş: "s",
  ş: "s",
  Ğ: "g",
  ğ: "g",
  Ü: "u",
  ü: "u",
  Ö: "o",
  ö: "o",
  Ç: "c",
  ç: "c",
};

// data-track-id values for the clickable elements with a fixed identity.
export const TRACK_IDS = Object.freeze({
  NAV_LOGO: "nav_logo",
  NAV_SEARCH: "nav_search",
  NAV_PROFILE_MENU: "nav_profile_menu",
  NAV_PROFILE_MANAGEMENT: "nav_profile_management",
  NAV_SETTINGS: "nav_settings",
  NAV_LOGOUT: "nav_logout",
  NAV_LOGIN: "nav_login",
  PLAYER_PLAY_PAUSE: "player_play_pause",
  PLAYER_REWIND_BACK: "player_rewind_back",
  PLAYER_REWIND_FORWARD: "player_rewind_forward",
  PLAYER_FULLSCREEN: "player_fullscreen",
  PLAYER_EXIT: "player_exit",
  PLAYER_RESTART: "player_restart",
  PLAYER_BACK_LIVE: "player_back_live",
  PLAYER_PIP: "player_pip",
  PLAYER_INFO: "player_info",
  PLAYER_PLAYBACK_RATE: "player_playback_rate",
  PLAYER_QUALITY: "player_quality",
  PLAYER_AUDIO: "player_audio",
  PLAYER_SUBTITLES: "player_subtitles",
  PLAYER_RECORD: "player_record",
  PLAYER_CHANNEL_LIST: "player_channel_list",
  DETAIL_RENT: "detail_rent",
  DETAIL_BUY: "detail_buy",
  DETAIL_PLAY: "detail_play",
  DETAIL_TAB_EPISODES: "detail_tab_episodes",
  DETAIL_TAB_DETAILS: "detail_tab_details",
  DETAIL_TAB_CAST: "detail_tab_cast",
  DETAIL_SEASON_SELECT: "detail_season_select",
  SETTINGS_BACK: "settings_back",
  SETTINGS_FAVLOCK_CHANNEL: "settings_favlock_channel",
  SETTINGS_PURCHASE_HISTORY: "settings_purchase_history",
  SETTINGS_RECORDS: "settings_records",
  SETTINGS_DOWNLOADS: "settings_downloads",
  SETTINGS_PARENTAL_CONTROL: "settings_parental_control",
  SETTINGS_LANGUAGE: "settings_language",
  SETTINGS_VERSION: "settings_version",
  SETTINGS_NOTIFICATIONS: "settings_notifications",
  SETTINGS_DEVICES: "settings_devices",
  POPUP_OK: "popup_ok",
  POPUP_YES: "popup_yes",
  POPUP_NO: "popup_no",
  POPUP_CANCEL: "popup_cancel",
  POPUP_CLOSE: "popup_close",
  POPUP_CONFIRM: "popup_confirm",
  HERO_POSTER: "hero_poster",
  HERO_PREVIEW: "hero_preview",
  HERO_WATCH_NOW: "hero_watch_now",
  HERO_GO_CHANNEL: "hero_go_channel",
  HERO_MORE_INFO: "hero_more_info",
  HERO_GO_LINK: "hero_go_link",
  HERO_GO_CATEGORY: "hero_go_category",
});

// True for ids the SDK keeps as is: lowercase snake case, starting with a
// letter, at most 64 characters and no 7+ digit numbers (PII mask).
export function isValidTrackId(id) {
  return (
    typeof id === "string" &&
    TRACK_ID_PATTERN.test(id) &&
    !LONG_NUMBER_PATTERN.test(id)
  );
}

// Builds a data-track-id from parts, skipping empty ones. Turkish letters
// become ASCII before lowercasing ("İ".toLowerCase() is "i" plus a dot).
// Returns undefined when the result is not a valid id, so React omits the
// attribute.
export function toTrackId(...parts) {
  try {
    const id = parts
      .filter((part) => part !== null && part !== undefined && part !== "")
      .map(String)
      .join("_")
      .replace(TURKISH_LETTER_PATTERN, (letter) => TURKISH_TO_ASCII[letter])
      .toLowerCase()
      .replace(/[^a-z0-9_]/g, "_")
      .replace(/_+/g, "_")
      .replace(/^_+|_+$/g, "")
      .replace(/\d{7,}/g, "n")
      .slice(0, MAX_TRACK_ID_LENGTH)
      .replace(/_+$/, "");

    return isValidTrackId(id) ? id : undefined;
  } catch (e) {
    return undefined;
  }
}
